import odata from '@/core/api/mixin/odata'
import rest from '@/core/api/mixin/rest'

export default {
  ...odata('api_keys'),
  ...rest('api_keys'),
}
